
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBipolar_transistor04On as ObiBipolar_transistor04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-bipolar_transistor-04-on.js';
 
 
 

 
 export const ObiBipolar_transistor04On = createComponent({
   react: React,
   tagName: 'obi-bipolar_transistor-04-on',
   elementClass: ObiBipolar_transistor04OnElement,
   events: {
     
   }
  });
 
 